import {useCallback} from "react";
import {call, select} from 'redux-saga/effects';

import {actionEffects as actions} from "../store/actions";
import {selectIsBlocked, selectProfile, selectUsername} from "../store/selectors";
import {useSagaCallback} from '../utils/sagas';
import {apiGet, apiPost, useGetRequestData} from './client';

export function* loadUserProfile() {
    const {users} = yield call(apiGet, "/api/v2/user/about.json?user=me");
    const {username} = users[0];
    const prevUser = yield select(selectUsername);
    yield actions.settingsLoaded(users[0]);
    if (prevUser !== username) {
        yield actions.userChanged();
    }
}

export const useReloadProfile = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* () {
        const {users} = yield call(apiGet, "/api/v2/user/about.json?user=me");
        const {username} = users[0];
        const prevUser = yield select(selectUsername);
        yield actions.settingsLoaded(users[0]);
        if (prevUser !== username) {
            yield actions.userChanged();
        }
    }, []))
};

export const useProfile = (feedbackCh, user) =>
    useGetRequestData(feedbackCh, `/api/v2/user/about.json?user=${user}`)?.users[0];

export function* saveSettings(changes) {
    const data = {...changes};
    if ('expand' in data) {
        data.expand = data.expand === 'card' ? 'true' : 'false';
    }
    if ('trending_topics' in data) {
        data.trending_topics = JSON.stringify(data.trending_topics);
    }
    if ('blocked_communities' in data) {
        data.blocked_communities = JSON.stringify(data.blocked_communities);
    }
    yield call(apiPost, `/api/v2/user/settings`, data);
}

export const useSaveSettings = (feedbackCh=null) => {
    return useSagaCallback(feedbackCh, saveSettings);
};

export const useBlock = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (username) {
        const {blocked} = yield select(selectProfile);
        const isBlocked = yield select(selectIsBlocked);
        const changed = isBlocked(username) ? [...blocked.filter(element => element !== username)] : [...blocked, username];
        yield actions.settingsChanged({blocked: changed});
        yield call(apiPost, `/api/v2/action/block`, {
            target: username
        });
    }, []));
};

export const useBlocks = (feedbackCh) =>
    useGetRequestData(feedbackCh, `/api/v2/user/blocked.json`);
